<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createProyectoClonar"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedAssetsContentModalDuplicate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mFeedAssetsContentModalDuplicate.messageDelete.element') }}
          <b>{{ element.titulo }}</b>
          {{ $t('mFeedAssetsContentModalDuplicate.messageDelete.options') }}
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedAssetsContentModalDuplicate.buttonCancel')"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedAssetsContentModalDuplicate',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedAssetsContentModalDuplicate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      showLoadingState: true
    }
  },

  created () {
    if (this.$modal.element === null) {
      this.readProyecto()
    } else {
      this.element = Object.assign({}, this.$modal.element)
      this.showLoadingState = false
    }
  },

  methods: {
    createProyectoClonar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('proyecto', 'createProyectoClonar', {}, [this.element.id])
          .then(response => {
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedAssetsContentModalDuplicate', 'createProyectoClonar', 'success')
            this.$router.push(`/${this.$t('rPaths.asset')}/${response.data.id}/${this.$t('mEditionMenu.asset.card.subject')}`)
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedAssetsContentModalDuplicate', 'createProyectoClonar', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    readProyecto () {
      this.$services.read('proyecto', 'readProyecto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
